import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { SITE_URL } from '@/lib/seo';

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <div className="pt-16 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-8 lg:px-12 py-3">
          <nav aria-label="breadcrumb">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li><a href="/" className="hover:text-primary-600 transition-colors">Home</a></li>
              <li><i className="ri-arrow-right-s-line text-xs" /></li>
              <li><span className="text-foreground-700">Contact</span></li>
            </ol>
          </nav>
        </div>
      </div>

      <main className="flex-1 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">Contact Us</h1>
        <p className="text-foreground-600 mb-8">
          Have questions or feedback about our guides? We would love to hear from you. Please reach out
          through our main website for the fastest response.
        </p>
        <div className="p-6 bg-background-50 rounded-xl border border-background-200">
          <p className="text-foreground-700 mb-4">
            For all inquiries, please visit our main website:
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors"
          >
            Visit kaspreadsheet.com
            <i className="ri-external-link-line" />
          </a>
        </div>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Contact AllChinaBuy Spreadsheet",
          "url": `${SITE_URL}/contact/`,
          "description": "Contact AllChinaBuy Spreadsheet for questions and feedback about our buying guides, QC tips and shipping resources."
        })}
      </script>
    </div>
  );
}